export enum COLOR_THEME {
  STAFF = 'staff',
  ADMIN = 'admin',
}
